import { Component, OnInit } from '@angular/core';
import { TaxService } from './tax-application.service';
import { TaxApplication } from './tax-application.model';
import { UntypedFormGroup, UntypedFormBuilder, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from '../../../core/custom-validators';
import { Router } from '@angular/router';


@Component({
  selector: 'app-tax-application',
  templateUrl: './tax-application.component.html',
  styleUrls: ['./tax-application.component.css']
})
export class TaxApplicationComponent implements OnInit {

  formbuilder: any;
  formGroup: any;
  taxData: TaxApplication = new TaxApplication();
  taxForm: UntypedFormGroup;
  formgroup: UntypedFormGroup;
  success: Boolean;
  today: Date;
  isFormEnabled: Boolean;
  

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private service: TaxService) {

  }
  public radioBtnOptions = [
    { value: 'Yes', display: 'Yes' },
    { value: 'No', display: 'No' }
  ];

  public paidOptions = [
    { value: 'Yes', display: 'Yes' },
    { value: 'No', display: 'No' },
    { value: 'Other', display: 'Other Explain:' }
  ];

  public applicationOptions = [
    { value: 'Broadband provider only', display: 'Broadband provider only' },
    { value: 'ILEC', display: 'ILEC' },
    { value: 'CLEC', display: 'CLEC' },
    { value: 'ILEC & CLEC Combined', display: 'ILEC & CLEC Combined' },
    { value: 'Other', display: 'Other' }
  ];
  public mask = '(000) 000-0000';
  ngOnInit() {

    this.taxForm = this.formBuilder.group({
      companyName: [null, Validators.compose([Validators.required, CustomValidators.noSpace])],
      personName: [null, Validators.compose([Validators.required, CustomValidators.noSpace])],
      emailAddress: [null, Validators.compose([Validators.required , CustomValidators.validEmail, CustomValidators.noSpace])],
      phoneNumber: [null, Validators.compose([Validators.required, CustomValidators.PhoneNumberValid, CustomValidators.noSpace])],
      invoiceNumber: [null, Validators.compose([Validators.required, CustomValidators.noSpace])],
      amountBilledLcsa: [null, Validators.compose([Validators.required , CustomValidators.numeric, CustomValidators.noSpace])],
      amountPaidLcsa: [null, Validators.compose([Validators.required , CustomValidators.numeric, CustomValidators.noSpace])],
      datePaid: [null, Validators.required],
      paid: [null, Validators.required],
      paidComments: [null],
      question10: [null, Validators.required],
      question11: [null, Validators.required],
      question11Comment: [null],
    });

    this.success = false;
    this.today = new Date();
    this.taxData.companyName = null;
    this.taxData.personName = null;
    this.taxData.invoiceNumber = null;
    this.taxData.paidComments = null;
    this.taxData.question11Comment = null;
    this.isFormEnabled = this.isLive();
    if(!this.isFormEnabled) {
      this.taxForm.disable();
    }
  }




  save() {

    if ((!this.taxForm.valid) || ((this.taxData.question11 === 'Other'
    && (this.taxData.question11Comment === '' ||
     this.taxData.question11Comment === 'undefined' || this.taxData.question11Comment === null)
  ) || (this.taxData.paid === 'Other'
    && (this.taxData.paidComments === '' || this.taxData.paidComments === 'undefined' || this.taxData.paidComments === null)
    ))) {
      Object.keys(this.taxForm.controls).forEach(key => {
        this.taxForm.get(key).markAsTouched();
      });
    } else {
      this.service.SaveTaxCreditData(this.taxData).subscribe(taxData => {
        if (taxData) {
          this.success = true;
        } else {
          this.success = false;
        }
      });
    }
  }

  resetQuestion9() {
    if (this.taxData.paid !== 'Other') {
      this.taxData.paidComments = null;
    }
  }
  resetQuestion11() {
    if (this.taxData.question11 !== 'Other') {
      this.taxData.question11Comment = null;
    }
  }

  Menu() {
    this.router.navigateByUrl('/forms-home');
  }

  goBack() {
    this.success = false;
    this.taxData = new TaxApplication();
    Object.keys(this.taxForm.controls).forEach(key => {
      this.taxForm.get(key).markAsUntouched();
    });
    this.ngOnInit();
  }

  isLive() {
    var currentYear = new Date().getFullYear();
    const startDate = (new Date(currentYear + '-05-01 00:00:00.000'));
    //const endDate = (new Date('2025-09-02 00:00:00.000'));
    return this.compareDatesWithoutYear(this.today, startDate) != -1;
    //  && this.compareDatesWithoutYear(this.today, endDate) ==-1;
  }

  compareDatesWithoutYear(date1: Date, date2: Date): number {
    const month1 = date1.getMonth();
    const day1 = date1.getDate();
    const month2 = date2.getMonth();
    const day2 = date2.getDate();

    if (month1 < month2 || (month1 === month2 && day1 < day2)) {
        return -1;
    } else if (month1 > month2 || (month1 === month2 && day1 > day2)) {
        return 1;
    } else {
        return 0;
    }
  }
}


